package io.horion.cv.pages.motivation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronUp
import com.varabyte.kobweb.silk.components.icons.fa.FaCircle
import com.varabyte.kobweb.silk.components.icons.fa.FaCircleArrowLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaCirclePlus
import com.varabyte.kobweb.silk.components.icons.fa.FaDownload
import com.varabyte.kobweb.silk.components.icons.fa.FaEye
import com.varabyte.kobweb.silk.components.icons.fa.FaPen
import com.varabyte.kobweb.silk.components.icons.fa.FaPenFancy
import com.varabyte.kobweb.silk.components.icons.fa.FaPenRuler
import com.varabyte.kobweb.silk.components.icons.fa.FaPencil
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.icons.fa.IconCategory
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.api.datasource.motivation.ModelLetter
import io.horion.cv.api.utils.TokenRepository
import io.horion.cv.components.AuthRequiredPopup
import io.horion.cv.components.LoadingPopup
import io.horion.cv.components.MissingFieldsPopup
import io.horion.cv.components.preview.LetterPreviewPanel
import io.horion.cv.components.widgets.MenuOption
import io.horion.cv.viewModel.LetterViewModel
import io.horion.cv.di.koinGet
import io.horion.cv.models.reaccordionSections
import io.horion.cv.pages.cv.Separator
import io.horion.cv.styles.AccordionContentPaddingStyle
import io.horion.cv.styles.AccordionRowStyle
import io.horion.cv.styles.DropdownTriggerIconStyle
import io.horion.cv.styles.DropdownTriggerStyle
import io.horion.cv.styles.InfoLetterDividerStyle
import io.horion.cv.styles.InfoLetterFormScrollContainerStyle
import io.horion.cv.styles.InfoLetterMainLayoutContainerStyle
import io.horion.cv.styles.InfoLetterPreviewContainerStyle
import io.horion.cv.styles.NavTitleTextStyle
import io.horion.cv.styles.NavigationBarContainerStyle
import io.horion.cv.styles.ReAccordionActionBoxStyle
import io.horion.cv.styles.ReAccordionActionIconStyle
import io.horion.cv.styles.ReAccordionActionPositionStyle
import io.horion.cv.styles.ReAccordionPlusIconStyle
import io.horion.cv.styles.ReAccordionRowContainerStyle
import io.horion.cv.styles.ReAccordionRowContentStyle
import io.horion.cv.styles.ReAccordionSectionPaddingStyle
import io.horion.cv.styles.ReAccordionTitleTextStyle
import io.horion.cv.styles.TelechargerButtonStyle
import io.horion.cv.styles.TelechargerRowStyle
import io.horion.cv.styles.ViewButtonStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.Dimens
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLInputElement
import kotlin.collections.forEach
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.icons.fa.IconSize.SM
import io.horion.cv.styles.DesktopOnlyStyle
import io.horion.cv.styles.DesktopOnlyStylecss
import io.horion.cv.styles.HideOnMobileStyle
import io.horion.cv.styles.MobileOnlyStyle
import io.horion.cv.styles.MobileOnlyStylecss
import io.horion.cv.styles.ReAccordionPlusIconStyles
import io.horion.cv.styles.downloadDesktopOnlyStyle
import io.horion.cv.styles.downloadMobileOnlyStyle
import org.jetbrains.compose.web.attributes.ARel
import com.varabyte.kobweb.compose.ui.graphics.Color



private val FIELD_LABELS = mapOf(
    "lastName"  to "Prénom(s)",
    "firstName" to "Nom(s) de famille",
    "email"     to "Adresse e-mail",
    "adresse"   to "Adresse",
    "phone"     to "Numéro de téléphone",
    "country"   to "Country",
    "city"      to "Ville"
)

private val FIELD_INPUT_IDS = mapOf(
    "lastName"  to "input-lastName",
    "firstName" to "input-firstName",
    "email"     to "input-email",
    "adresse"   to "input-address",
    "phone"     to "input-phone",
    "country"   to "country",
    "city"      to "ville"
)

@OptIn(DelicateApi::class)
@Page("/info_letter_page")
@Composable
fun InfoLetterPage() {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val ctx = rememberPageContext()
    val letterViewModel = koinGet<LetterViewModel>()
    //var openedSectionId by remember { mutableStateOf<String?>(null) }
    val model = ctx.route.params["model"]

    LaunchedEffect(model) {
        model?.let {
            ModelLetter.entries
                .firstOrNull { entry -> entry.name == it }
                ?.let { letterViewModel.updateModel(it) }
        }
    }

    Div(attrs = {
        style {
            property("display", "flex")
            property("flex-direction", "column")
            property("height", "100vh")
            property("width", "100%")
            property("overflow", "hidden")
            property("background-color", if (isDark) Colors.DarkBG else Colors.White)
        }
    }) {
        Navigationbar(isDark = isDark)

        Div(attrs = InfoLetterMainLayoutContainerStyle.toModifier().toAttrs()) {
            // Colonne gauche : Formulaire scrollable
            Div(attrs = InfoLetterFormScrollContainerStyle.toModifier().toAttrs()) {
                FormContentLetter(isDark = isDark)
            }

            // Séparateur vertical (masqué sur mobile via CSS)
            Div(attrs = InfoLetterDividerStyle.toModifier().toAttrs())

            // Colonne droite : Preview (masquée sur mobile via CSS)
            Div(attrs = InfoLetterPreviewContainerStyle.toModifier().toAttrs()) {
                LetterPreviewPanel(
                    letterUiState = letterViewModel.letterUiState,
                    model = letterViewModel.letterUiState.model
                )
            }
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
fun FormContentLetter(
    isDark: Boolean,
    submitLabel: String = "Télécharger",
    onCustomSubmit: (() -> Unit)? = null
) {
    var openedSectionId by remember { mutableStateOf<String?>(null) }

    Column(modifier = Modifier.fillMaxWidth()) {
        val allSections = reaccordionSections

        allSections.forEach { section ->
            val isOpen = section.id == openedSectionId

            ReAccordionRow(
                title = section.title,
                isOpen = isOpen,
                onClick = {
                    openedSectionId = if (isOpen) null else section.id
                },
                isDark = isDark
            )

            if (!isOpen) {
                Separator()
            }

            Box(
                modifier = ReAccordionSectionPaddingStyle.toModifier()
                    .fillMaxWidth()
                    .styleModifier {
                        property("max-height", if (isOpen) "2000px" else "0px")
                        property("opacity", if (isOpen) "1" else "0")
                        property("transition", "max-height 500ms ease-in-out, opacity 300ms ease-in-out")
                    }
                    .overflow(Overflow.Hidden)
            ) {
                if (isOpen) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(topBottom = 25.px)
                    ) {
                        section.content()
                    }
                }
            }

            if (isOpen) {
                Separator()
            }
        }

        Box(modifier = Modifier.padding(5.px))

        Box(modifier = HideOnMobileStyle.toModifier()
            .fillMaxWidth()) {
            TelechargerButton(
                onCustomSubmit = onCustomSubmit
            )
        }

        // ── Mobile : bouton Preview ──
        Box(modifier = downloadMobileOnlyStyle.toModifier().fillMaxWidth()) {
            PreviewButton(
                onCustomSubmit = onCustomSubmit
            )
        }


    }
}
@Composable
fun ClearOption(
    isOpen: Boolean,
    onDismiss: () -> Unit,
    onClear: () -> Unit,
    breakpoint: Breakpoint
) {
    if (isOpen) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .position(Position.Fixed)
                .top(0.px)
                .left(0.px)
                .zIndex(999)
                .onClick {
                    onDismiss()
                }
        )
        Box(
            modifier = Modifier
                .position(Position.Absolute)
                .top(if (breakpoint >= Breakpoint.MD) 45.px else 20.px)
                .right(0.px)
                .width(if (breakpoint >= Breakpoint.MD) 250.px else 150.px)
                .backgroundColor(Colors.input)
                .borderRadius(8.px)
                .boxShadow(
                    offsetX = 0.px,
                    offsetY = 2.px,
                    blurRadius = 10.px,
                    spreadRadius = 2.px,
                    color = rgba(0, 1, 6, 0.1)
                )
                .padding(8.px)
                .zIndex(1000)
                .onClick {
                    onClear()    // Vide les champs
                    onDismiss()
                }
        ) {
            Column(
                modifier = Modifier.fillMaxWidth()
            ) {

                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(leftRight = if (breakpoint >= Breakpoint.MD) 20.px else 10.px, topBottom =  if (breakpoint >= Breakpoint.MD) 10.px else 5.px)
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically
                    ) {

                        Image(
                            src = "/clear-icon.svg",
                            description = "clear icon",
                            modifier = Modifier
                                .size(if (breakpoint >= Breakpoint.MD) 24.px else 20.px)
                                .margin(right = 20.px)
                        )
                        SpanText(
                            text = "Clear Section",
                            modifier = Modifier
                                .fontSize(if (breakpoint >= Breakpoint.MD) 16.px else 12.px)
                                .color(Colors.White)
                                .fontFamily(INTER)
                                .fontWeight(FontWeight.Normal)
                                .flexGrow(1)
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun Navigationbar(isDark: Boolean) {
    val letterViewModel = koinGet<LetterViewModel>()

    val iconFilter = if (isDark) "none" else "invert(1)"
    val textColor = if (isDark) Colors.White else Colors.Primary

    var isDropdownOpen by remember { mutableStateOf(false) }
    var selectedMenuOption by remember { mutableStateOf<String?>("rename") }

    var isEditing by remember { mutableStateOf(false) }
//    var title by remember { mutableStateOf("Lettre de motivation sans titre") }
    var title = letterViewModel.motivationLetterTitle
    var inputRef by remember { mutableStateOf<HTMLInputElement?>(null) }

    fun finishTitleEdition() {
        title = title.trim()

        if (title.isBlank()) {
            title = "Lettre de motivation sans titre"
        }

        isEditing = false
    }
    //  Focus automatique
    LaunchedEffect(isEditing) {
        if (isEditing) {
            inputRef?.focus()
            inputRef?.select()
        }
    }

    Row(
        modifier = NavigationBarContainerStyle.toModifier()
            .fillMaxWidth()
            .padding(leftRight = 20.px)
            .borderBottom(1.px, LineStyle.Solid, Colors.DarkGray),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween
    ) {

        // 🔙 Retour
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.cursor(Cursor.Pointer)
        ) {
            Link(
                path = "/motivation",
                modifier = Modifier.textDecorationLine(TextDecorationLine.None)
            ) {
                Row(verticalAlignment = Alignment.CenterVertically) {

                    Box(
                        contentAlignment = Alignment.Center,
                        modifier = Modifier
                            .size(24.px)
                            .borderRadius(50.percent)
                            .backgroundColor(Colors.White)
                            .border(1.px, LineStyle.Solid, Colors.Black)
                            .onClick {
                                window.history.back()
                            }
                    ) {
                        FaArrowLeft(
                            modifier = Modifier
                                .fontSize(12.px)
                                .color(Colors.Black)
                        )
                    }

                    SpanText(
                        "Retour",
                        modifier = HideOnMobileStyle.toModifier()
                            .margin(left = 10.px)
                            .fontFamily(INTER)
                            .fontSize(16.px)
                            .color(textColor)
                    )
                }
            }
        }

        // TITRE
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.weight(1f),
            horizontalArrangement = Arrangement.Center
        ) {
            if (isEditing) {

                Input(
                    type = InputType.Text,
                    attrs = Modifier
                        .fontFamily(INTER)
                        .fontSize(16.px)
                        .fontWeight(FontWeight.Bold)
                        .color(textColor)
                        .toAttrs {
                            value(title)

                            ref { element ->
                                inputRef = element
                                onDispose {
                                    inputRef = null
                                }
                            }

                            onInput {
                                letterViewModel.updateMotivationLetterTitle(it.value)
                            }

                            onBlur {
                                finishTitleEdition()
                                letterViewModel.finishMotivationLetterTitleEdition()
                            }

                            onKeyDown {
                                when (it.key) {

                                    "Enter" -> {
                                        it.preventDefault()
                                        finishTitleEdition()
                                        letterViewModel.finishMotivationLetterTitleEdition()
                                        isEditing = false
                                    }

                                    "Escape" -> {
                                        it.preventDefault()
                                        isEditing = false
                                    }
                                }
                            }
                        }
                )

            } else {

                SpanText(
                    title,
                    modifier = NavTitleTextStyle
                        .toModifier()
                        .fontFamily(INTER)
                        .fontSize(16.px)
                        .fontWeight(FontWeight.Bold)
                        .color(textColor)
                        .cursor(Cursor.Text)
                        .onClick {
                            isEditing = true
                        }
                        .styleModifier {
                            property("overflow", "hidden")
                            property("text-overflow", "ellipsis")
                            property("white-space", "nowrap")
                        }
                )
                FaPen(
                    modifier = Modifier
                        .padding(left = 5.px)
                        .margin(right = 14.px)
                        .onClick {
                            isEditing = true
                        },
                    size = SM
                )
            }
        }

        //  ACTIONS
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(10.px)
        ) {

           /*          DOTS (toujours visible)
            Box(
            modifier = DropdownTriggerStyle.toModifier()
            .border(1.px, LineStyle.Solid, Colors.Placeholder)
            .borderRadius(7.px)
                .onClick {
                    isDropdownOpen = !isDropdownOpen
                },
            contentAlignment = Alignment.Center
        ) {
            Image(
                src = "dots-vertical.svg",
                modifier = DropdownTriggerIconStyle.toModifier()
            )
        }

            MenuOption(
                isOpen = isDropdownOpen,
                onDismiss = { isDropdownOpen = false },
                selectedOption = selectedMenuOption,
                triggerBottomPx = 0.0,
                onOptionClick = { optionId ->
                    selectedMenuOption = optionId

                    when (optionId) {
                        "rename" -> {
                            isEditing = true
                            isDropdownOpen = false
                        }
                    }
                }
            )*/

            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(10.px)
            ) {
                Box(modifier = HideOnMobileStyle.toModifier()) {
                    TelechargerButton()
                }
            }
            //mobile
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(10.px)
            ) {
                Box(modifier = downloadMobileOnlyStyle.toModifier()) {
                    PreviewButton(
                        label = "",
                    )
                }
            }
        }
    }
}

@Composable
fun TelechargerButton(
        label: String = "Télécharger",
        onCustomSubmit: (() -> Unit)? = null ) {

        val ctx = rememberPageContext()
        val scope = rememberCoroutineScope()
        val letterViewModel = koinGet<LetterViewModel>()
        // État pour afficher ou non le popup
        var showAuthModal by remember { mutableStateOf(false) }
        var isAuthenticated by remember { mutableStateOf(false) }
        var showMissingFieldsModal by remember { mutableStateOf(false) }

        if (showAuthModal) {
            AuthRequiredPopup(
                onDismiss = { showAuthModal = false },
                onConfirm = {
                    showAuthModal = false
                    TokenRepository.redirectToAuth()
                }
            )
        }
        if (showMissingFieldsModal) {
            MissingFieldsPopup(
                missingFields = letterViewModel.missingFieldIds,
                onDismiss = { showMissingFieldsModal = false }
            )
        }
        LaunchedEffect(letterViewModel.letterUiState.letterCreateSuccess){
            if (onCustomSubmit == null && letterViewModel.letterUiState.letterCreateSuccess) {
                ctx.router.navigateTo("/payment")
            }
        }

        LoadingPopup(letterViewModel.letterUiState.loading)


//        Box(Modifier.height(dimens.boxHeight))

        Row(
            modifier = TelechargerRowStyle.toModifier(),
            horizontalArrangement = Arrangement.End
        ) {
            Box(
                modifier = Modifier
                    .position(Position.Relative)
                    .display(DisplayStyle.InlineBlock)
            ) {
                Button(
                    onClick = {
                        val isValid = letterViewModel.validateRequiredFields()
                        if (isValid) {
                            scope.launch {
                                runCatching {
                                    isAuthenticated = TokenRepository.checkAuthentication()
                                }.getOrNull()

                                if (isAuthenticated) {
                                    if (onCustomSubmit != null) onCustomSubmit() else letterViewModel.createLetter()
                                } else {
                                    showAuthModal = true
                                }
                            }
                        } else {
                            showMissingFieldsModal = true
                            val firstMissing = letterViewModel.missingFieldIds.firstOrNull()
                            val inputId = firstMissing?.let { FIELD_INPUT_IDS[it] }
                            if (inputId != null) {
                                val el = document.getElementById(inputId)
                                println(inputId)

                                el?.asDynamic()?.focus()
                                el?.asDynamic()?.scrollIntoView(
                                    js("({ behavior: 'smooth', block: 'center' })")
                                )
                            }
                        }
                    },
                    modifier = ViewButtonStyle.toModifier()
                        .then(TelechargerButtonStyle.toModifier())
                        .borderRadius(7.px)
                        .fontFamily(INTER)
                        .fontWeight(FontWeight.Normal)
                ) {
                    FaDownload(
                        modifier = Modifier
                            .margin(right = 14.px),
                        size = IconSize.SM
                    )
                    SpanText(label)
                }
            }
        }
    }

 @Composable
    fun PreviewButton(
        label: String = "Prévisualiser",
        onCustomSubmit: (() -> Unit)? = null
    ) {

        val ctx = rememberPageContext()
        val scope = rememberCoroutineScope()
        val letterViewModel = koinGet<LetterViewModel>()
        // État pour afficher ou non le popup
        var showAuthModal by remember { mutableStateOf(false) }
        var isAuthenticated by remember { mutableStateOf(false) }
        var showMissingFieldsModal by remember { mutableStateOf(false) }

        if (showAuthModal) {
            AuthRequiredPopup(
                onDismiss = { showAuthModal = false },
                onConfirm = {
                    showAuthModal = false
                    TokenRepository.redirectToAuth()
                }
            )
        }
        if (showMissingFieldsModal) {
            MissingFieldsPopup(
                missingFields = letterViewModel.missingFieldIds,
                onDismiss = { showMissingFieldsModal = false }
            )
        }
        LaunchedEffect(letterViewModel.letterUiState.letterCreateSuccess){
            if (onCustomSubmit == null && letterViewModel.letterUiState.letterCreateSuccess) {
                ctx.router.navigateTo("/payment")
            }
        }

        LoadingPopup(letterViewModel.letterUiState.loading)

    // Définir des valeurs réactives basées sur le breakpoint

//        Box(Modifier.height(dimens.boxHeight))

        Row(
            modifier = TelechargerRowStyle.toModifier(),
            horizontalArrangement = Arrangement.End
        ) {
            Box(
                modifier = Modifier
                    .position(Position.Relative)
                    .display(DisplayStyle.InlineBlock)
            ) {
                Button(
                    onClick = {
                        val isValid = letterViewModel.validateRequiredFields()
                        if (isValid) {
                            ctx.router.navigateTo("/letterpreview")

                            /*scope.launch {
                                runCatching {
                                    isAuthenticated = TokenRepository.checkAuthentication()
                                }.getOrNull()

                                if (isAuthenticated) {
                                    if (onCustomSubmit != null) onCustomSubmit() else letterViewModel.createLetter()
                                } else {
                                    showAuthModal = true
                                }
                            }*/
                        } else {
                            showMissingFieldsModal = true
                            val firstMissing = letterViewModel.missingFieldIds.firstOrNull()
                            val inputId = firstMissing?.let { FIELD_INPUT_IDS[it] }
                            if (inputId != null) {
                                val el = document.getElementById(inputId)
                                println(inputId)

                                el?.asDynamic()?.focus()
                                el?.asDynamic()?.scrollIntoView(
                                    js("({ behavior: 'smooth', block: 'center' })")
                                )
                            }
                        }
                    },
                    modifier = if (label.isEmpty()) {
                        ViewButtonStyle.toModifier()
                            .size(42.px)
                            .borderRadius(7.px)
                            .fontFamily(INTER)
                            .fontWeight(FontWeight.Normal)
                    } else {
                        ViewButtonStyle.toModifier()
                            .then(TelechargerButtonStyle.toModifier())
                            .borderRadius(7.px)
                            .fontFamily(INTER)
                            .fontWeight(FontWeight.Normal)
                    }
                ) {
                    FaEye(
                        modifier = Modifier.then(
                            if (label.isNotEmpty()) {
                                Modifier.margin(right = 14.px)
                            } else {
                                Modifier
                            }
                        ),
                        size = IconSize.SM
                    )
                    if (label.isNotEmpty()) {
                        SpanText(label)
                    }
                }
            }
        }
    }



@Composable
fun ReAccordionRow(
    title: String,
    isOpen: Boolean,
    onClick: () -> Unit,
    isDark: Boolean
) {
    val titleColor = if (isOpen) {
        if (isDark) Colors.White else Colors.Primary
    } else {
        Colors.Placeholder
    }

    Column(
        modifier = ReAccordionSectionPaddingStyle.toModifier().fillMaxWidth()
    ) {
        Box(
            modifier = AccordionRowStyle.toModifier()
                .fillMaxWidth()
                .cursor(Cursor.Pointer)
                .onClick { onClick() }
                .position(Position.Relative),
            contentAlignment = Alignment.CenterStart
        ) {
            Row(
                modifier = ReAccordionRowContentStyle.toModifier(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                SpanText(
                    text = title,
                    modifier = ReAccordionTitleTextStyle.toModifier()
                        .color(titleColor)
                        .fontFamily(INTER)
                        .fontWeight(FontWeight.SemiBold)
                        .whiteSpace(WhiteSpace.NoWrap)
                )
            }

            Row(
                modifier = ReAccordionActionPositionStyle.toModifier()
                    .position(Position.Absolute)
                    .top(50.percent)
                    .translateY((-50).percent),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(10.px)
            ) {
                if (isOpen) {
                    Box(
                        modifier = ReAccordionActionBoxStyle.toModifier()
                            .border(1.px, LineStyle.Solid, Colors.Placeholder)
                            .borderRadius(7.px),
                        contentAlignment = Alignment.Center
                    ) {

                        FaChevronUp(
                            modifier = ReAccordionActionIconStyle
                                .toModifier()
                                .cursor(Cursor.Pointer)
                                .color(Color.rgb(0xb5, 0xb5, 0xb5))
                        )

                    }
                } else {

                    Box(
                        contentAlignment = Alignment.Center,
                        modifier = ReAccordionPlusIconStyle.toModifier()
                            .borderRadius(50.percent)
                            .backgroundColor(Colors.White)
                            .border(1.5.px, LineStyle.Solid, Color.rgb(0xb5, 0xb5, 0xb5))

                    ) {
                        FaPlus(
                            modifier = ReAccordionPlusIconStyles.toModifier()
                                .color(Color.rgb(0xb5, 0xb5, 0xb5))
                        )
                    }

                }
            }
        }
    }
}